import React from 'react';
import SectionBundleReceiptEntry from '../SectionBundleReceiptEntry';

const ITGoodsBundleReceiptEntry = () => {
  return (
    <SectionBundleReceiptEntry
      sectionName="IT Goods"
      sectionDisplayName="IT Goods Section"
      backRoute="/sections/it-goods"
    />
  );
};

export default ITGoodsBundleReceiptEntry;
